import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useNavigate } from "react-router-dom";

const EmailVerificationFailed = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ backgroundColor: "#F4F6F9", minHeight: "100vh", py: 10 }}>
      <Container
        maxWidth="sm"
        sx={{
          backgroundColor: "#FFFFFF",
          borderRadius: 2,
          boxShadow: 3,
          overflow: "hidden",
          textAlign: "center",
        }}
      >
        <Box sx={{ backgroundColor: "#2E4053", color: "#FFFFFF", py: 4 }}>
          <ErrorOutlineIcon sx={{ fontSize: 50 }} />
          <Typography variant="h4" mt={1}>
            Verification Failed
          </Typography>
        </Box>

        <Box sx={{ p: 4 }}>
          <Typography variant="h5" color="#2E4053" gutterBottom>
            Token Invalid or Expired
          </Typography>
          <Typography variant="body1" color="text.secondary">
            The verification link is no longer valid. It may have expired or
            already been used.
          </Typography>
          <Button
            variant="contained"
            onClick={() => navigate("/RegistrationSuccess")}
            sx={{
              mt: 4,
              backgroundColor: "#2E4053",
              "&:hover": {
                backgroundColor: "#1c2a36",
              },
            }}
          >
            Resend Verification Email
          </Button>
        </Box>

        <Box sx={{ fontSize: 12, color: "#A6AAAD", py: 2 }}>
          &copy; 2025 Spade. All rights reserved.
        </Box>
      </Container>
    </Box>
  );
};

export default EmailVerificationFailed;
